module.exports = __webpack_public_path__ + "img/shous.0d8e6829.png";